<!--
 * @Descripttion: iframe属性配置
 * @Author: zenghua.wang
 * @Date: 2021-11-17 09:30:19
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:07:21
-->

<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- iframe设置 -->
    <el-collapse-item title="iframe设置">
      <el-form-item label="隐藏">
        <el-switch
          v-model="data.option.hide"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="地址">
        <el-input
          v-model="data.option.source"
          type="textarea"
          :rows="4"
          placeholder="如：http://www.wiseloong.com"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import { theme, component } from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-iframe',
  components: {
    configBase,
    configAuth
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      component: component
    }
  }
}
</script>
